/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credit: NonNullable<unknown> }} Seat_Price_Credit_NowInputs */



/**
* | output |
* | --- |
* | "Your team's AI credit grows by {credit} today." |
*
* @param {Seat_Price_Credit_NowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_credit_now = /** @type {((inputs: Seat_Price_Credit_NowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_Credit_NowInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das KI-Guthaben Ihres Teams wächst heute um ${i?.credit}.`)
	return /** @type {LocalizedString} */ (`Your team's AI credit grows by ${i?.credit} today.`)
});